const properties = [
	'id',
	'name',
	'clubTeamName',
	'email',
	'description',
	'category',
	'imageUrl',
	'backgroundImageUrl',
	'players',
	'club',
];

class Team {
	id = null;

	name = null;

	clubTeamName = null;

	email = null;

	description = null;

	category = null;

	imageUrl = null;

	backgroundImageUrl = null;

	players = null;

	club = null;

	constructor(props) {
		if (props) {
			for (const key of properties) {
				if (key in props) {
					this[key] = props[key];
				}
			}

			if (!this.players) {
				this.players = [];
			}
		}
	}

	get realName() {
		return this.club?.code ?? this.name;
	}
}

export default Team;
